module.exports = __webpack_public_path__ + "img/deadline.f43e46c.svg";